import CryptoJS from "crypto-js";
//For the moment our License is not valid to generate a hash
import { PUBLIC_SOCIAL_TOURNAMENT_API_KEY } from "$env/static/public";

export const generateUserHash = (username: string, externalUserId: number, partnerName: string): string => {
  const requestData = {
    username,
    external_user_id: externalUserId,
    st_partner_name: partnerName,
  };

  const sortedKeys = Object.keys(requestData).sort();
  let requestString = sortedKeys.map((key) => `${key}=${requestData[key]}`).join("+");

  // Hardcoded ST_LICENSE value from PragmaticPlay demo, should be replaced soon
  requestString += `+${PUBLIC_SOCIAL_TOURNAMENT_API_KEY}`;

  // Crypto-js has to be used since native Crypto is limited with Vite
  const hash = CryptoJS.MD5(requestString).toString();

  return hash;
};
